<template>
  <div>
    <el-row class="row" :gutter="10">
      <el-col :span="7">
        <my-approval title="homes.pendingMyApproval" :items="processCountItems" />
      </el-col>
      <el-col :span="11">
        <overdue-list @more="overdueMore" />
      </el-col>
      <el-col :span="6">
        <quick-link />
      </el-col>
    </el-row>
    <el-row class="row" :gutter="10">
      <el-col :span="12">
        <company-tech />
      </el-col>
      <el-col :span="12">
        <project-phase />
      </el-col>
    </el-row>
    <el-row class="row" :gutter="10">
      <el-col :span="24">
        <patent-top-10 @more="topTenMore" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import myApproval from './components/myApproval'
import overdueList from './components/overdueList'
import quickLink from './components/quickLink'
import companyTech from './components/companyTech'
import projectPhase from './components/projectPhase'
import patentTop10 from './components/patentTop10'

import { todoProcessCount } from '@/api/homes'

export default {
  components: {
    'my-approval': myApproval,
    'overdue-list': overdueList,
    'quick-link': quickLink,
    'company-tech': companyTech,
    'project-phase': projectPhase,
    'patent-top-10': patentTop10
  },
  mixins: [],
  props: {},
  data() {
    return {
      processCountItems: [
        {
          num: 0,
          text: 'homes.companyProcess',
          path:'/companyManagement/CompanyProcessAudit',
          query:{ state: 'pending'}
        },
        {
          num: 0,
          text: 'homes.projectProcess',
          path:'/projectManagement/projectProcessAudit',
          query:{ state: 'pending'}
        }
      ]
    }
  },
  computed: {},
  watch: {},
  created() {
    /** 待我审批项 */
    todoProcessCount().then(resp => {
      var data = resp.data
      this.processCountItems[0].num = data.todoCompanyCount
      this.processCountItems[1].num = data.todoProjectCount
    })
  },
  mounted() {},
  destroyed() {},
  methods: {
    overdueMore(){
      this.$router.push({ path: '/projectManagement/projectListView', query: { overdue: '1',isAvaliable:0 }})
    },
    topTenMore(){
      this.$router.push({ path: "/patentManagement/patentListView", query: {mainType: 1}});
    }
  }
}
</script>
<style lang="scss" scoped>
.row {
  margin-bottom: 10px;
}
</style>
